/* eslint-disable react/sort-comp */
import React from 'react';
import { makeStyles } from '@material-ui/core';
import { Button } from '@michelin/acid-components';
import {
  CentralProviderHeader,
  CentralProviderHeaderV3,
  CurrentLocationAvatar,
  usePermissions,
  useTranslation,
} from '@michelin/central-provider';
import { useUIVersion } from 'contexts/UIVersionContext';
import { useHistory } from 'react-router-dom';

const useStyles = makeStyles(() => ({
  interfaceSwitcher: {
    position: 'fixed',
    top: 0,
    left: '50%',
    transform: 'translateX(-50%)',
    height: 65,
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    zIndex: 1201,
  },
  selected: {
    backgroundColor: '#FCE500',
    color: '#222',
    '&:hover': {
      backgroundColor: '#FFD600',
    },
  },
  unselected: {
    color: '#ffffff',
    '&:hover': {
      color: '#ffffff',
      backgroundColor: 'rgba(255,255,255,0.24)',
    },
  },
}));

export function Heading() {
  const classes = useStyles();
  const { isNewUI, toggleUIVersion, featureEnabled } = useUIVersion();
  const history = useHistory();
  const permissions = usePermissions();
  const { t } = useTranslation();

  const handleSwitch = () => {
    const customerNumber = permissions.location?.customer_number;
    if (!isNewUI) {
      history.push(`/${customerNumber}/home`);
    } else {
      history.push(`/${customerNumber}`);
    }
    toggleUIVersion();
  };

  const HeaderToRender = featureEnabled ? (
    <CentralProviderHeaderV3
      appTitle="Michelin"
      logoType="blueBackgroundPoweredByMichelin"
      customLink={
        <CurrentLocationAvatar allowedAccountTypes="fleet" allowedCountryCodes={['US', 'CA']} enableStateFiltering />
      }
      profileMenuItems={[]}
    />
  ) : (
    <CentralProviderHeader
      appTitle="Michelin"
      logoType="michelin"
      customLink={
        <CurrentLocationAvatar allowedAccountTypes="fleet" allowedCountryCodes={['US', 'CA']} enableStateFiltering />
      }
      profileMenuItems={[]}
    />
  );

  return (
    <>
      <div>
        {HeaderToRender}
        {featureEnabled && (
          <div id="tour-step-interface-toggle" className={classes.interfaceSwitcher}>
            <Button
              variant={!isNewUI ? 'text' : 'contained'}
              className={!isNewUI ? classes.unselected : classes.selected}
              style={{ textTransform: 'none' }}
              onClick={() => !isNewUI && handleSwitch()}
            >
              {t('New Interface')}
            </Button>
            <Button
              variant={isNewUI ? 'text' : 'contained'}
              className={isNewUI ? classes.unselected : classes.selected}
              style={{ textTransform: 'none' }}
              onClick={() => isNewUI && handleSwitch()}
            >
              {t('Legacy Interface')}
            </Button>
          </div>
        )}
      </div>
    </>
  );
}
